module.exports = __webpack_public_path__ + "static/img/home_new18.48432842.jpg";